module.exports = __webpack_public_path__ + "img/logo-x7trade-white-blue-nobg.c16e0a0c.svg";